module.exports = __webpack_public_path__ + "static/img/img4.20e5ce5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scenariusze/img/img4.png
// module id = FgET
// module chunks = 0